import { useEffect, useRef, useState } from 'react';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import useAuth from '../../../hooks/useAuth';
import { getVisitPreSaleFeedbackEndpoint } from '../services/dashboardService';

// Provisional: calcula en el cliente qué asesorías finalizadas no tienen
// feedback del Proper (un GET por visita, con caché). Reemplazar por un campo
// `has_feedback` en la lista / un contador en las métricas cuando backend lo
// exponga.
const usePendingFeedbackVisits = (doneVisitIds: string[], enabled: boolean) => {
  const { callEndpoint } = useCallApiAndLoad();
  const { getAuthToken } = useAuth();
  const token = getAuthToken();
  const cache = useRef<Map<string, boolean>>(new Map()); // id -> pendiente
  const [pendingIds, setPendingIds] = useState<Set<string>>(new Set());
  const [ready, setReady] = useState(false);
  const key = doneVisitIds.join(',');

  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    (async () => {
      const missing = doneVisitIds.filter((id) => !cache.current.has(id));
      await Promise.all(
        missing.map(async (id) => {
          const { status } = await callEndpoint(
            getVisitPreSaleFeedbackEndpoint(id, token),
          );
          if (status === 404) cache.current.set(id, true);
          else if (status === 200) cache.current.set(id, false);
        }),
      );
      if (!active) return;
      setPendingIds(
        new Set(doneVisitIds.filter((id) => cache.current.get(id) === true)),
      );
      setReady(true);
    })();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, enabled]);

  return { pendingIds, ready };
};

export default usePendingFeedbackVisits;
